module.exports = __webpack_public_path__ + "img/interview-logo.02bf8721.svg";